import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { addSnackbar } from '../redux/slices/snackbar';

const useError = () => {
  const dispatch = useDispatch();

  const handleError = useCallback((error: any) => {
    const data = error.response?.data;
    const details = error.response?.data?.detail;
    const code = error.response?.data?.code;
    const status = error.response?.status;

    // If it's Network Error that we got not from BE
    let message = '';
    if (!error.status) message = error.message;

    // Some responces can have a list of errors
    if (code === 'multiple') {
      error.response?.data?.list.forEach((err) => {
        dispatch(addSnackbar({ message: err.detail }));
      });
    } else if (
      status === 400
      && data
      && typeof data === 'object'
      && !data?.detail
      && Object.keys(data).length > 0
    ) {
      for (const key in data) {
        if (Array.isArray(data[key])) {
          const fieldErrors = data[key];
          fieldErrors.forEach((errMsg) => {
            dispatch(addSnackbar({ message: errMsg }));
          });
        }
      }
    } else {
      dispatch(addSnackbar({ message: details || message }));
    }
  }, []);

  return [handleError];
};

export default useError;
